<div class="asset-type">
	@let isActiveUS_EQUITY = activeAssetClass() === assetClassEnum.US_EQUITY;
	<app-button
		[appearance]="isActiveUS_EQUITY ? 'dark' : 'flat'"
		size="s"
		(clicked)="changeAssetClass(assetClassEnum.US_EQUITY)"
	>
		{{ 'assetType.stocks' | translate }}
	</app-button>
	<app-button
		[appearance]="!isActiveUS_EQUITY ? 'dark' : 'flat'"
		size="s"
		(clicked)="changeAssetClass(assetClassEnum.US_OPTION)"
	>
		{{ 'assetType.options' | translate }}
	</app-button>
</div>
